export function dehydrate(rawData) {
  return rawData.name
}

export function hydrate(name) {
  return { name }
}
